import { Cart3D } from '../../app/basket-3d-slice';
import { buttonStyle } from '../../controls/buttons';
import { useMessages2 } from '../../hooks/useLanguage';
import { ConfiguratorLayout } from '../../view/configurator-layout/configurator-layout';
import { SidebarFixed, SidebarScrollable } from '../../view/sidebar';
import ViewControl from '../../view/view-controls';

import styles from './cart-3d-panel.module.css';
import { Cart } from '../../app/types/api-types';
import Popup from '../../controls/popup/popup';

export function Cart3DPanel({ loading, cartId, cart, cart3D, onAddProduct, onShowBasket }: {
    loading: boolean
    cartId?: number
    cart3D?: Cart3D
    cart?: Cart
    onAddProduct?: () => void
    onShowBasket?: () => void;
}) {

    const { messages } = useMessages2();

    const addProductDisabled = cartId === undefined || cart === undefined;

    const sidebarContent = <>
        <SidebarScrollable>
            { cart ? <CartSidebar cart={cart}/> : ( messages?.basket_loading ?? '' ) }
        </SidebarScrollable>
        <SidebarFixed className={styles.buttons}>
            <button className={buttonStyle} disabled={cartId === undefined} onClick={onShowBasket}>{ messages?.show_basket_button ?? ''}</button>
           
            {/*<button className={buttonStyle} disabled={addProductDisabled} onClick={onAddProduct}>{ messages?.basket_add_product ?? '' }</button> */ }
           
        </SidebarFixed>
    </>

    return <ConfiguratorLayout
        sidebarTitle={ messages?.my_basket_title ?? '' }
        sidebarContent={sidebarContent}
        overlayFooter={ <ViewControl resetCameraBehaviour="fit" show2D={true} legendOptions={{legendType:'basket3d'}}/> }
        loading={loading}>
        <Popup/>
    </ConfiguratorLayout>

}

function CartSidebar({ cart }: {
    cart: Cart
}) {

    const { messages } = useMessages2();

    return <ul className={styles.basketList}>
        { cart.baskets.map(basket => {
            const quantity = Number(basket.quantity);            
            return <li key={basket.shoppingbasketID}>
                <img src={import.meta.env.VITE_PICTURES_BASE + basket.picture.replace(/^\/wwwserver\/wwwroot/, '')} />
                <div className={styles.basketHeader}>
                    <span>{ basket.modeldescription }</span>
                    { quantity > 1 ? <span className={styles.basketHeaderInfo}> ({'\u2a2f'}{quantity})</span>
                                   : null} 
                </div>
                <div className={styles.articles}>
                {
                    basket.lines.map((line,ddIdx) => <div key={ddIdx} className={styles.article} role="presentation">
                        <p className={styles.artDDText}>{line.description}</p>
                        <p className={styles.artDDCode}>{(messages?.basket_detail_code ?? '').replace('${code}', line.externalcodes)}</p>
                    </div>)
                }
                </div>
            </li>
        })}
    </ul>

}